import React, { useState } from "react";
import "./App.css";
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope, FaPaperPlane } from "react-icons/fa";

function Test() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ===== SEND MAIL FUNCTION =====
  const sendMail = async (e) => {
    e.preventDefault();
    setLoading(true);

    const res = await fetch("http://localhost:3000/send-mail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    const data = await res.json();
    setLoading(false);

    if (data.success) {
      alert("Message sent successfully!");
      setForm({ name: "", email: "", phone: "", message: "" });
    } else {
      alert("Something went wrong!");
    }
  };

  return (
    <div className="contact-section">
      <div className="contact-container">

        {/* CONTACT FORM */}
        <div className="form-card">
          <h2 className="form-title">Let's Connect</h2>
          <p className="form-subtitle">GET IN TOUCH</p>

          <form className="contact-form" onSubmit={sendMail}>
            <div className="form-group">
              <input type="text" name="name" placeholder="Your Name"
                className="form-input" value={form.name} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <input type="email" name="email" placeholder="Email Address"
                className="form-input" value={form.email} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <input type="tel" name="phone" placeholder="Phone Number"
                className="form-input" value={form.phone} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <textarea name="message" placeholder="Your Message" rows="5"
                className="form-textarea" value={form.message} onChange={handleChange} required />
            </div>

            <button className="submit-btn" type="submit">
              <FaPaperPlane className="send-icon" />
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>

        {/* CONTACT INFO */}
        <div className="info-card">
          <div className="info-header">
            <div className="phone-icon-container">
              <FaPhoneAlt className="phone-icon" />
            </div>
            <h2 className="info-title">Contact Us</h2>
          </div>

          <p className="info-description">
            Get Ready To Create Great With Me
          </p>

          <div className="info-item">
            <div className="info-icon"><FaMapMarkerAlt /></div>
            <div className="info-content">
              <h3>Our Location</h3>
              <p>Ashok Nagar, Sakinaka, Mumbai - 400072</p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon"><FaPhoneAlt /></div>
            <div className="info-content">
              <h3>Phone Number</h3>
              <p>+91 9920 818 454</p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon"><FaEnvelope /></div>
            <div className="info-content">
              <h3>Email Address</h3>
              <p>princeguptak22@gmail.com</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Test;
